import { NgModule, ModuleWithProviders } from '@angular/core';
import { ROLES_TYPE } from './constants/consts';
import { Enum } from '../common/interfaces/enum.interface';
import { CoreAuthService } from './services/core-auth.service';
import { AuthHandlerService } from './services/auth-handler.service';
import { AuthGuard } from './guards/auth.guard';
import { TransferHttpCacheModule } from '@nguniversal/common';

@NgModule({
  imports: [TransferHttpCacheModule],
  declarations: [],
  providers:[],
  exports: []
})
export class AuthModule {
  static forRoot(roles: Enum): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        {
          provide: ROLES_TYPE,
          useValue: roles
        },
        CoreAuthService,
        AuthHandlerService,
        AuthGuard
      ]
    }
  }
}
